import "./plugins";
import "./globalComponents";
// import ahmadyarLogo from "./logos/ahmadyar.js";
// import ahmadyarWatermark from "./logos/ahmadyar_watermark.js";
import Vue from "vue";
import curjs from "currency.js";
import writtenNumber from "written-number";
import "./plugins/wordifyfa/wordifyfa.js";

let numberMap = {
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
    "۰": "0"
};
// external libraries
import { store } from "@/store";
import xl_tables from "./plugins/excelExport/xl_tables";

// global vue components

Vue.directive("english", function(el, binding, vnode) {
    if (binding.value != binding.oldValue) {
        let a = binding.value + "";
        a = a.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function(c) {
            return c.charCodeAt(0) & 0xf;
        });
        vnode.componentInstance.$emit("input", a);
    }
});

Vue.filter("round", function(value, accuracy, keep) {
    if (typeof value != "number") return value;
    var fixed = value.toFixed(accuracy);
    return keep ? fixed : +fixed;
});

Vue.filter("persianDateFilter", function(
    georgian_date,
    convert = false,
    time = false
) {
    if (georgian_date && convert && !time)
        return new Date(georgian_date)
            .toLocaleDateString("fa")
            .replace(/[۰-۹]/g, function(match) {
                return numberMap[match];
            })
            .replace(/،/g, ",");
    else return georgian_date;
});

Vue.filter("toWord", function(num) {
    let n = curjs(num, { precision: 0 }).value;
    let lang = "en";
    if (localStorage.getItem("lang")) {
        lang = JSON.parse(localStorage.getItem("lang")).value;
    }
    if (lang == "en") return writtenNumber(n, { lang: "en" });
    return wordifyfa(n);
});
Vue.filter('abs', function(num){
    return Math.abs(num) || num
})

Vue.mixin({
    methods: {
        xl_tables,
        userCan(value) {
            return store.getters["AuthModule/permissions"].indexOf(value) > -1;
        },
       
        toWord(num) {
            let lang = "en";
            if (localStorage.getItem("lang")) {
                lang = JSON.parse(localStorage.getItem("lang")).value;
            }
            if (lang == "fa") return wordifyfa(num);
            return writtenNumber(num, { lang: "en" });
        },

        persianDateFilter(georgian_date, convert = false, time = false) {
            if (georgian_date && convert && !time)
                return new Date(georgian_date)
                    .toLocaleDateString("fa")
                    .replace(/[۰-۹]/g, function(match) {
                        return numberMap[match];
                    })
                    .replace(/،/g, ",");
            else return georgian_date;
        },

        smbl(id, fa = false) {
            let currency = store.getters.currencies[id];
            if (fa) return currency ? currency.fa_name : "";
            return currency ? currency.name : "";
        },

        disableBackDate() {
            return this.userBranch.disable_back_date;
        }
    },

    computed: {
        userBranch() {
            return store.getters["AuthModule/branch"];
        },
        user() {
            return this.$store.getters["AuthModule/current_user"]["user"];
        },
        isRTL() {
            return this.$vuetify.rtl;
        }
    },

    
    data() {
        //name, main.styl, mixins, dashboard/index.vue store/index.js, login.vue, branch.php, index.html
        return {
            APP_LOGO_SIZE: "20mm", //20mm,
            afn_currency_id: 2,
            base_currency_id: 1,
            branch_watermark: "",
            generate_description: true,
            APP_LOGO: require("./assets/images/msp-pro.svg"),
            qrcode: require("./assets/images/qrcode_kabulmsp.png"),
            APP_LOGO_DARK: require("./assets/images/msp-pro-dark.svg"),
            per_page: [{ text: "All", value: 99999999 }, 500, 200, 100],
            // APP_LOGO: require("./assets/images/finwavelight.svg"),
            // APP_LOGO_DARK: require("./assets/images/finwavedark.svg"),
            
            // APP_NAME: "MSP Pro",
            // branch_name: "MSP Pro",
            // company_email: "info@pts.af",
            // branch_email: "info@msppro.com",
            // LONG_APP_NAME: "MSP & FXD Company",
            // branch_fa_name: "سیستم صرافی و خدمات پولی",
            // branch_ps_name: "د صرافی او پولی خدماتی شرکت",
            // branch_logo: require("./assets/images/msp-pro.svg"),
            // qrcode: require("./assets/images/qrcode_kabulmsp.png"),

            // APP_NAME: "Saleem Caravan",
            // branch_name: "Saleem Caravan",
            // company_email: "info@pts.af",
            // branch_email: "info@saleemcaravanmsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی سلیم کاروان",
            // branch_ps_name: " د سلیم کاروان صرافی و پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/saleem.jpg"),
            // qrcode: require("./assets/images/asiapool_qrcode.jpg"),
            // LONG_APP_NAME: "Saleem Caravan exchange and money services Provider Co",
            
            // APP_NAME: "Asia Pool",
            // branch_name: "Asia Pool",
            // company_email: "info@pts.af",
            // branch_email: "info@asiapoolfxdmsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی آسیا پول",
            // branch_ps_name: " د آسیا پول صرافی و پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/asiapool.png"),
            // qrcode: require("./assets/images/asiapool_qrcode.jpg"),
            // LONG_APP_NAME: "Asiapool Exchange and Money Service Provider Co",

            // APP_NAME: "Habibyar MSP",
            // branch_name: "Habibyar MSP",
            // company_email: "info@pts.af",
            // branch_email: "info@habibyarmsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی حبیب یار",
            // branch_ps_name: " د حبیب یار صرافی و پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/habibyar.jpg"),
            // LONG_APP_NAME: "Habibyar Exchange & Money Service Providers Co",

            // APP_NAME: "Perozi MSP",
            // branch_name: "Perozi MSP",
            // company_email: "info@pts.af",
            // branch_email: "info@perozimsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی پیروزی",
            // branch_ps_name: " د پیروزی صرافی و پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/perozimsp.png"),
            // LONG_APP_NAME: "Perozi Exchange & Money Services Co",

            // APP_NAME: "Dunya MSP",
            // branch_name: "Dunya MSP",
            // company_email: "info@pts.af",
            // branch_email: "info@dunyamsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی دنیا",
            // branch_ps_name: " د دنیا صرافی و پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/dunya.png"),
            // LONG_APP_NAME: "Dunya Exchange & Money Services Co",
            

            // APP_NAME: "MSP Pro",
            // branch_name: "Aria Ghaznawi",
            // company_email: "info@pts.af",
            // LONG_APP_NAME: "Aria Ghaznawi Exchange & MSP. LTD",
            // branch_email: "info@ariaghaznawimsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی آریا غزنوی",
            // branch_ps_name: "د آریا غزنوی صرافی او پولی خدماتی شرکت",
            // qrcode: require("./assets/images/qrcode_kabulmsp.png"),
            // branch_logo: require("./assets/images/ariaghaznawi.jpeg"),

            branch_name: "Herat MSP Co",
            company_email: "info@pts.af",
            APP_NAME: "Herat FXD and MSP Co",
            branch_email: "info@heratmsp.com",
            branch_fa_name: "شرکت صرافی و خدمات پولی پیروزی",
            branch_logo: require("./assets/images/herat.jpg"),
            LONG_APP_NAME: "Perozi Exchange & Money Services Co",
            branch_ps_name: "د هرات  صرافی او پولی خدمات شرکت",
            qrcode: require("./assets/images/qrcode_heratmsp.png"),

            // company_email: "info@pts.af",
            // APP_NAME: "Kawoon Motahed",
            // branch_name: "Kawoon Motahed",
            // LONG_APP_NAME: "Kawoon Motahed Exchange & Money Service Co",
            // branch_fa_name: "شرکت صرافی و خدمات پولی کاوون متحد",
            // branch_email: "info@kawoonmotahedfxd.com",
            // branch_ps_name: " د کاوون متحد صرافی او پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/kawoon.jpg"),

            // company_email: "info@pts.af",
            // branch_name: "Qadiri FXD & MSP",
            // APP_NAME: "Qadiri Fxd & MSP Co",
            // branch_email: "info@qadir-imsp.com",
            // LONG_APP_NAME: "Qadiri Fxd & MSP Co",
            // branch_fa_name: "شرکت صرافی و خدمات پولی قدیری",
            // branch_ps_name: " د قدیری صرافی او پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/qadiri.png"),

            // branch_name: "Rashid Faiz FXD",
            // company_email: "info@pts.af",
            // APP_NAME: "Rashid Faiz FXD",
            // branch_email: "Rashidfaizmoneyservice@gmail.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی راشد فایض",
            // branch_logo: require("./assets/images/rashidfaiz.jpeg"),
            // LONG_APP_NAME: "Rashid Faiz FXD & MSP‌ Co",
            // branch_ps_name: "د راشد فایض صرافی او پولی خدمات شرکت",
            // qrcode: require("./assets/images/qrcode_heratmsp.png"),


            // APP_NAME: "Kabul MSP Co",
            // company_email: "info@pts.af",
            // branch_name: "Kabul Exchange",
            // branch_email: "info@kabulmsp.com",
            // branch_fa_name: "شرکت صرافی و خدمات پولی کابل",
            // branch_ps_name: "د کابل صرافی او پولی خدمات شرکت",
            // LONG_APP_NAME: "Kabul Exchange & Money Service Co.",
            // qrcode: require("./assets/images/qrcode_kabulmsp.png"),
            // branch_logo: require("./assets/images/kabulmsp.svg"),
            // branch_hrz_logo: require("./assets/images/kabulmsp_horzinatllogo.jpeg"),


            // APP_NAME: "KA‌ MSP‌ & FXD",
            // branch_name: "KA MSP & FXD",
            // company_email: "info@pts.af",
            // branch_email: "info@kamsp.com",
            // qrcode: require("./assets/images/qrcode_heratmsp.png"),
            // branch_logo: require("./assets/images/ka_no_title.png"),
            // branch_fa_name: "شرکت صرافی و خدمات پولی حاجی خلیل احمد الکوزی",
            // branch_ps_name: "د حاجی خلیل احمد الکوزی صرافی او پولی خدمات شرکت",
            // LONG_APP_NAME: "Khalil Ahmad Alokozay Exchange & Money Services Co",

            // APP_NAME: "Sikandari FXD",
            // branch_name: "Sikandari FXD",
            // LONG_APP_NAME: "Sikandari FXD Co",
            // company_email: "info@pts.af",
            // branch_email: "info@sikandarifxd.com",
            // branch_fa_name: "شرکت صرافی سکندری",
            // branch_ps_name: " د سکندری پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/sikandari.png"),

            // APP_NAME: "Osmani MSP",
            // branch_name: "Osmani MSP",
            // LONG_APP_NAME: "Osmani MSP Co",
            // company_email: "info@pts.af",
            // branch_email: "info@osmanimsp.com",
            // branch_fa_name: "شرکت خدمات پولی عثمانی",
            // branch_ps_name:" د عثمانی پیسو خدماتو شرکت",
            // branch_logo: require("./assets/images/oem.png"),
        };
    }
});